import Marionette from 'backbone.marionette';

export default Marionette.Behavior.extend({
  // without this, including behaviors causes some views to fail to render
  setupRegions() {
  }
});
